'use strict';

const googleFieldMapping = {
    GB: {
        street_number: 'houseNumber',
        route: 'street',
        postal_town: 'city',
        postal_code: 'postalCode'
    },
    RU: {
        street_number: 'address1',
        route: 'address1',
        locality: 'city',
        postal_code: 'postalCode'
    },
    IE: {
        street_number: 'houseNumber',
        route: 'street',
        postal_town: 'city',
        locality: 'city',
        postal_code: 'postalCode',
        administrative_area_level_1: 'state'
    },
    NO: {
        street_number: 'houseNumber',
        route: 'street',
        postal_town: 'city',
        locality: 'city',
        postal_code: 'postalCode'
    },
    SE: {
        street_number: 'houseNumber',
        route: 'street',
        postal_town: 'city',
        locality: 'city',
        postal_code: 'postalCode'
    },
    US: {
        street_number: 'address1',
        route: 'address1',
        locality: 'city',
        postal_code: 'postalCode',
        administrative_area_level_1: 'stateUS'
    },
    default: {
        street_number: 'houseNumber',
        route: 'street',
        locality: 'city',
        postal_code: 'postalCode'
    }
};

const irelandGoogleCountyFieldMapper = {
    CW: 'CW',
    CN: 'CV',
    CE: 'CL',
    CO: 'CK',
    DL: 'DG',
    D: 'DB',
    G: 'GW',
    KY: 'KY',
    'COUNTY KILDARE': 'KD',
    'COUNTY KILKENNY': 'KK',
    LS: 'LS',
    LM: 'LM',
    LK: 'LI',
    LD: 'LF',
    LH: 'LT',
    MO: 'MY',
    MH: 'MT',
    MN: 'MH',
    OY: 'OF',
    RN: 'RC',
    SO: 'SG',
    TA: 'TP',
    WD: 'WF',
    WH: 'WM',
    WX: 'WX',
    WW: 'WW'
};

module.exports = {
    googleFieldMapping,
    irelandGoogleCountyFieldMapper
};
